import { StartupActionsApi } from './api/StartupActionsApi';
import { DiscoveryApi } from '@backstage/core-plugin-api';
import { handleFailedResponse } from '@agilelab/plugin-wb-platform-common';
import { StartupActionsResponse } from './types';

export class StartupActionsClient implements StartupActionsApi {
  private readonly discoveryApi: DiscoveryApi;

  constructor(options: { discoveryApi: DiscoveryApi }) {
    this.discoveryApi = options.discoveryApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('startup-actions');
  }

  async getActions(): Promise<StartupActionsResponse> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/status`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    await handleFailedResponse(response);
    return response.json();
  }

  async triggerActions(): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/trigger`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    await handleFailedResponse(response);
  }
}
